class ImageManager {
    static imageMap = new Set()

    static setImage(image) {
        this.imageMap.add(image)
    }

    static clearImages() {
        for (let imageMapElement of this.imageMap) {
            imageMapElement.src = ''
        }
    }
}

export {
    ImageManager
}
